<template>
  <section>
    <v-row class="ma-0">
      <v-col
        v-for="(method, methodIndex) in items"
        :key="methodIndex"
        :cols="cols"
        :md="md"
        @click="onSelect(method)"
      >
        <v-hover v-slot="{ hover }">
          <v-card
            flat
            ripple
            width="100%"
            height="100%"
            :elevation="hover ? 2 : 0"
            class="cursor--pointer pa-2"
            :class="{
              'card--selected': method.equalTo(selectedPaymentMethod),
            }"
          >
            <v-row class="ma-0 mb-1" justify="center">
              <v-img :src="method.PictureUrl" max-width="45" max-height="45" />
            </v-row>
            <h4 class="text-center">{{ method.DisplayName }}</h4>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>

    <v-expand-transition :duration="{ enter: 1, leave: 0.5 }">
      <v-row
        v-if="
          selectedPaymentMethod != null && selectedPaymentMethod.Info !== ''
        "
        class="ma-0 mt-3 text-body-2 text--secondary method-info flex-nowrap"
      >
        <v-icon class="mr-3" color="grey">info</v-icon>
        <span>{{ selectedPaymentMethod.Info }}</span>
      </v-row>
    </v-expand-transition>

    <v-expand-transition>
      <v-alert v-model="hasError" type="error" dense class="mt-3">
        {{ errorMsg }}
      </v-alert>
    </v-expand-transition>
  </section>
</template>

<script>
import PaymentMethodObj from '@/objects/PaymentMethod';

export default {
  name: 'PaymentMethodSelect',
  props: {
    // Selected payment method
    value: {
      validator: (v) => v == null || v instanceof PaymentMethodObj,
    },
    // Array of PaymentMethod object [PaymentMethod]
    items: Array,
    cols: {
      type: Number,
      default: 4,
    },
    md: {
      type: Number,
      default: 2,
    },
  },
  emits: ['input'],
  data() {
    return {
      selectedPaymentMethod: this.value,
      hasError: false,
      errorMsg: '',
    };
  },
  computed: {
    hasItems() {
      return this.items != null && this.items.length > 0;
    },
  },
  watch: {
    value() {
      this.selectedPaymentMethod = this.value;
    },
  },
  methods: {
    onSelect(method) {
      this.selectedPaymentMethod = method;
      this.validate();
      this.$emit('input', this.selectedPaymentMethod);
    },
    /**
     * Method that can be used by parent to validate the selection
     */
    validate() {
      if (this.hasItems && this.selectedPaymentMethod == null) {
        this.errorMsg = this.$translate(
          'SELECT_PAYMENT_METHOD_NO_SELECT_ERROR'
        );
        this.hasError = true;
        return false;
      }
      this.errorMsg = '';
      this.hasError = false;
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
.card--selected {
  outline: 2px solid var(--primary-color);
}
.method-info {
  padding: 10px 10px;
  border-radius: 4px;
  background-color: white;
}
</style>
